import { LANGUAGE, messages } from "2g-i18n";
import { localeData } from "2g-utils-intl";

import messagesAppFooter from "b2b/components/app-footer/i18n";
import messagesAutocompletes from "b2b/components/autocompletes/i18n";
import messagesAuth from "b2b/components/auth/i18n";
import messagesCookiesContent from "b2b/components/cookies-content/i18n";
import messagesDoplnkovaSluzbaDetail from "b2b/components/doplnkova-sluzba-detail/i18n";
import messagesDoplnkovaSluzbaEditaceWidget from "b2b/components/doplnkova-sluzba-editace-widget/i18n";
import messagesDoplnkoveSluzbyGrid from "b2b/components/doplnkove-sluzby-grid/i18n";
import messagesDoplnkoveSluzbyGridColumns from "b2b/components/doplnkove-sluzby-grid-columns/i18n";
import messagesFixniNarokyNasledujici from "b2b/components/fixni-naroky-nasledujici/i18n";
import messagesFixniPozadavkyBox from "b2b/components/fixni-pozadavky-box/i18n";
import messagesFormSwitches from "b2b/components/form-switches/i18n";
import messagesKonfiguracniParametryWidget from "b2b/components/konfiguracni-parametry-editace-widget/i18n";
import messagesNotifikace from "b2b/components/notifikace/i18n";
import messagesPrilohy from "b2b/components/prilohy/i18n";
import messagesProduktDetail from "b2b/components/produkt-detail/i18n";
import messagesProduktEditaceWidget from "b2b/components/produkt-editace-widget/i18n";
import messagesProduktyGrid from "b2b/components/produkty-grid/i18n";
import messagesProduktyGridColumns from "b2b/components/produkty-grid-columns/i18n";
import messagesProjektVytvoreni from "b2b/components/projekt-vytvoreni/i18n";
import messagesProjektyGrid from "b2b/components/projekty-grid/i18n";
import messagesProjektyGridColumns from "b2b/components/projekty-grid-columns/i18n";
import messagesProvozniInformaceCards from "b2b/components/provozni-informace-cards/i18n";
import messagesProvozniInformaceDetailWidget from "b2b/components/provozni-informace-detail-widget/i18n";
import messagesProvozniInformaceEditaceWidget from "b2b/components/provozni-informace-editace-widget/i18n";
import messagesProvozniInformaceForm from "b2b/components/provozni-informace-form/i18n";
import messagesProvozniInformacePosledniWidget from "b2b/components/provozni-informace-posledni-widget/i18n";
import messagesProvozniInformaceSearch from "b2b/components/provozni-informace-search/i18n";
import messagesProvozniInformaceWidget from "b2b/components/provozni-informace-widget/i18n";
import messagesRenderers from "b2b/renderers/i18n";
import messagesRezervace from "b2b/pages/rezervace/i18n";
import messagesRezervaceVytvoreni from "b2b/components/rezervace-vytvoreni/i18n";
import messagesRezervaceWidget from "b2b/components/rezervace-widget/i18n";
import messagesZadostDetail from "b2b/components/zadost-detail/i18n";
import messagesZadostEditaceWidget from "b2b/components/zadost-editace-widget/i18n";
import messagesZadostiGridColumns from "b2b/components/zadosti-grid-columns/i18n";
import messagesSmlouvaVytvoren from "b2b/components/smlouva-vytvoreni/i18n";
import messagesSmlouvyGrid from "b2b/components/smlouvy-grid/i18n";
import messagesSmlouvyGridColumns from "b2b/components/smlouvy-grid-columns/i18n";
import messagesUzivateleGrid from "b2b/components/uzivatele-grid/i18n";
import messagesUzivateleGridColumns from "b2b/components/uzivatele-grid-columns/i18n";
import messagesZadostiGroups from "b2b/components/zadosti-groups/i18n";
import messagesZadostiHistorieGrid from "b2b/components/zadosti-historie-grid/i18n";
import messagesZadostiRowDetail from "b2b/components/zadosti-row-detail/i18n";
import messagesZadostiOdbaveniGrid from "b2b/components/zadosti-odbaveni-grid/i18n";
import messagesZadostiOdbaveniWidget from "b2b/components/zadosti-odbaveni-widget/i18n";
import messagesZadostiOdsouhlaseneWidget from "b2b/components/zadosti-odsouhlasene-widget/i18n";
import messagesZakazniciGrid from "b2b/components/zakaznici-grid/i18n";
import messagesZakazniciGridColumns from "b2b/components/zakaznici-grid-columns/i18n";
import messagesZakaznikDetail from "b2b/components/zakaznik-detail/i18n";
import messagesZdrojDetail from "b2b/components/zdroj-detail/i18n";
import messagesZdrojEditaceWidget from "b2b/components/zdroj-editace-widget/i18n";
import messagesZdrojeGrid from "b2b/components/zdroje-grid/i18n";
import messagesZdrojeGridColumns from "b2b/components/zdroje-grid-columns/i18n";
import messagesZdrojeTypyGrid from "b2b/components/zdroje-typy-grid/i18n";
import messagesZdrojeTypyGridColumns from "b2b/components/zdroje-typy-grid-columns/i18n";

import messagesGlobal from "./global";
import messagesNavigation from "./navigation";
import messagesPageTitles from "./pageTitles";

const LANGUAGES = [LANGUAGE.CZECH, LANGUAGE.ENGLISH];
const MESSAGES_ALL = [
  messages,

  messagesAppFooter,
  messagesAutocompletes,
  messagesAuth,
  messagesCookiesContent,
  messagesDoplnkovaSluzbaDetail,
  messagesDoplnkovaSluzbaEditaceWidget,
  messagesDoplnkoveSluzbyGrid,
  messagesDoplnkoveSluzbyGridColumns,
  messagesFixniNarokyNasledujici,
  messagesFixniPozadavkyBox,
  messagesFormSwitches,
  messagesKonfiguracniParametryWidget,
  messagesNotifikace,
  messagesPrilohy,
  messagesProduktDetail,
  messagesProduktEditaceWidget,
  messagesProduktyGrid,
  messagesProduktyGridColumns,
  messagesProjektVytvoreni,
  messagesProjektyGrid,
  messagesProjektyGridColumns,
  messagesProvozniInformaceCards,
  messagesProvozniInformaceDetailWidget,
  messagesProvozniInformaceEditaceWidget,
  messagesProvozniInformaceForm,
  messagesProvozniInformacePosledniWidget,
  messagesProvozniInformaceSearch,
  messagesProvozniInformaceWidget,
  messagesRenderers,
  messagesRezervace,
  messagesRezervaceVytvoreni,
  messagesRezervaceWidget,
  messagesZadostDetail,
  messagesZadostEditaceWidget,
  messagesZadostiGridColumns,
  messagesSmlouvaVytvoren,
  messagesSmlouvyGrid,
  messagesSmlouvyGridColumns,
  messagesUzivateleGrid,
  messagesUzivateleGridColumns,
  messagesZadostiGroups,
  messagesZadostiHistorieGrid,
  messagesZadostiRowDetail,
  messagesZadostiOdbaveniGrid,
  messagesZadostiOdbaveniWidget,
  messagesZadostiOdsouhlaseneWidget,
  messagesZakazniciGrid,
  messagesZakazniciGridColumns,
  messagesZakaznikDetail,
  messagesZdrojDetail,
  messagesZdrojEditaceWidget,
  messagesZdrojeGrid,
  messagesZdrojeGridColumns,
  messagesZdrojeTypyGrid,
  messagesZdrojeTypyGridColumns,

  messagesGlobal,
  messagesNavigation,
  messagesPageTitles
];

export default localeData.mergeLocaleData(LANGUAGES, MESSAGES_ALL);
